import * as ActionTypes from 'actions';
import Calendar from 'lib/Calendar';

/* eslint no-console: ["error", { allow: ["error"] }] */

const initialState = {
  schedules: [],
  schedule_details: {},
  schedule_events: [],
  isLoading: false,
  response: {},
};

export default function(state = initialState, action = {}) {
  const { type, response, id, error, payload } = action;
  const { byId } = state;

  switch (type) {
  case ActionTypes.SCHEDULE_LIST_REQUEST:
    return Object.assign({}, state, { schedules: [], isLoading: true });

  case ActionTypes.SCHEDULE_LIST_SUCCESS: {
    const schedules = response.data.length ? response.data : {};

    return Object.assign({}, state, { schedules: schedules, response, isLoading: false });
  }

  case ActionTypes.SCHEDULE_LIST_FAILURE:
    console.error('Error loading schedules', error);

    return Object.assign({}, state, { response, isLoading: false });


  case ActionTypes.SCHEDULE_VIEW_REQUEST:
    return Object.assign({}, state, { schedule_details: {}, schedule_events: [], isLoading: true });

  case ActionTypes.SCHEDULE_VIEW_SUCCESS: {
    const main_event = response.main ? response.main : {};
    const massagedEvents = response.events.map((event) => {
      const massaged = Calendar.massageEvent(event);
      return massaged;
    });

    return Object.assign({}, state, { schedule_details: main_event, schedule_events: massagedEvents, response, isLoading: false });
  }

  case ActionTypes.SCHEDULE_VIEW_FAILURE: {
    console.error('Error loading event', id, error);

    return Object.assign({}, state, { response, isLoading: false });
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/schedule.js